import { submitForm } from './externalForm';

export const subscribeToOurBlog = (data) => {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    const submitUrl =
        'https://forms.hubspot.com/uploads/form/v2/5944738/018d8c8a-b102-464f-a7a2-e219a71a73dc';

    const formData = {
        email: data.email,
    };

    return submitForm({
        url: submitUrl,
        data: formData,
    }).catch((error) => console.log(error));
};
